import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import { RsSentry } from '@rs-shared-lib/utils/rs-senty-init';
import * as Sentry from '@sentry/angular';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeEn from '@angular/common/locales/en-GB';
import localeDe from '@angular/common/locales/de';
import { appConfig } from '@app/app.config';

registerLocaleData(localeFr);
registerLocaleData(localeNl);
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe);

new RsSentry({
  dsn: 'https://686dfc8afdda767ea6b946c5ad2ef24c@o268277.ingest.us.sentry.io/4508799597019137',
  enabled: environment.enableSentryMonitoring,
  environment: environment.environment,
  sentryReleaseName: environment.sentryReleaseName,
}).sentryInit();

Sentry.getCurrentScope().setTag('app.name', 'ORD-ADMIN');
Sentry.getCurrentScope().setTag('app.environment', environment.environment);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
